import * as React from "react";
import { Link } from "gatsby";
import Bio from "../components/bio";
import Layout from "../components/layout";
import Seo from "../components/seo";
const BlogPostTemplate = props => {
    var _site$siteMetadata, _post$frontmatter, _post$frontmatter2, _previous$frontmatter, _next$frontmatter;
    const { data, location } = props;
    const { previous, next, site, markdownRemark: post } = data;
    const siteTitle = (site === null || site === void 0 ? void 0 : (_site$siteMetadata = site.siteMetadata) === null || _site$siteMetadata === void 0 ? void 0 : _site$siteMetadata.title) || "Title";
    return /*#__PURE__*/ React.createElement(Layout, {
        location: location,
        title: siteTitle
    }, /*#__PURE__*/ React.createElement("article", {
        className: "blog-post",
        itemScope: true,
        itemType: "http://schema.org/Article"
    }, /*#__PURE__*/ React.createElement("header", null, /*#__PURE__*/ React.createElement("h1", {
        itemProp: "headline"
    }, post === null || post === void 0 ? void 0 : (_post$frontmatter = post.frontmatter) === null || _post$frontmatter === void 0 ? void 0 : _post$frontmatter.title), /*#__PURE__*/ React.createElement("p", null, post === null || post === void 0 ? void 0 : (_post$frontmatter2 = post.frontmatter) === null || _post$frontmatter2 === void 0 ? void 0 : _post$frontmatter2.date)), /*#__PURE__*/ React.createElement("section", {
        dangerouslySetInnerHTML: {
            __html: post === null || post === void 0 ? void 0 : post.html
        },
        itemProp: "articleBody"
    }), /*#__PURE__*/ React.createElement("hr", null), /*#__PURE__*/ React.createElement("footer", null, /*#__PURE__*/ React.createElement(Bio, null))), /*#__PURE__*/ React.createElement("nav", {
        className: "blog-post-nav"
    }, /*#__PURE__*/ React.createElement("ul", {
        style: {
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "space-between",
            listStyle: "none",
            padding: 0
        }
    }, /*#__PURE__*/ React.createElement("li", null, previous && /*#__PURE__*/ React.createElement(Link, {
        to: previous.fields.slug,
        rel: "prev"
    }, "\u2190 ", (_previous$frontmatter = previous.frontmatter) === null || _previous$frontmatter === void 0 ? void 0 : _previous$frontmatter.title)), /*#__PURE__*/ React.createElement("li", null, next && /*#__PURE__*/ React.createElement(Link, {
        to: next.fields.slug,
        rel: "next"
    }, (_next$frontmatter = next.frontmatter) === null || _next$frontmatter === void 0 ? void 0 : _next$frontmatter.title, " \u2192")))));
};
export const Head = props => {
    var _frontmatter, _post$frontmatter3;
    const { data: { markdownRemark: post } } = props;
    return /*#__PURE__*/ React.createElement(Seo, {
        title: (_frontmatter = post.frontmatter) === null || _frontmatter === void 0 ? void 0 : _frontmatter.title,
        description: (post === null || post === void 0 ? void 0 : (_post$frontmatter3 = post.frontmatter) === null || _post$frontmatter3 === void 0 ? void 0 : _post$frontmatter3.description) || (post === null || post === void 0 ? void 0 : post.excerpt)
    });
};
export default BlogPostTemplate;
const pageQuery = "3085459379";
